import React, { Component } from 'react';
import { MDBIcon, MDBInput } from 'mdbreact';
import Swal from 'sweetalert2';
import { CargueImagenes, SeccionPMaestroCoopVirtual_, SeccionPMaestroCoopVirtualPOST_ } from '../../../services/WebAPI_Utrahuilca';
import FileUploaderIcon from './SElemento/FileUploaderIcon';

const validate = values => {
    const errors = {}
    if (values.titulo === '') {
        errors.posicion = 'campo obligatorio'
    }
    if (values.descripcion === '') {
        errors.descsimulador = 'campo obligatorio'
    }
    if (values.idtipopers === 'DEFAULT') {
        errors.idtipopers = 'campo obligatorio'
    }
    return errors;
};

class SElemento extends Component {
    uploader = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            titulo: '',
            idtipopers: '',
            rutaiconotit: '',
            descripcion: '',
            errors: {},
            estadoCambioImg: false,
            elementosData: [],
            editrutaiconotit: '',
            editdescripcion: '',
            edittitulo: '',
            estado: null,
            estadoImagen: false,
            idSeleccionado: null,
            idPintar: 0
        }
    }

    async componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idmaestrocoopv: 0,
            idtipopers: 0,
            titulo: 'NA',
            rutaiconotit: 'NA',
            descripcion: 'NA',
            estado: 0,
            idusucrea: 1
        }
        SeccionPMaestroCoopVirtual_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({
                                estadoNuevo: true
                            })
                        } else {
                            this.setState({
                                idSeleccionado: response.data[0].idmaestrocoopv,
                                elementosData: response.data,
                                editrutaiconotit: response.data[0].rutaiconotit,
                                editdescripcion: response.data[0].descripcion,
                                edittitulo: response.data[0].titulo,
                                estado: response.data[0].estado,
                                estadoNuevo: false,
                                estadoImagen: true,
                                idPintar: response.data[0].idmaestrocoopv
                            })
                            document.getElementById('' + response.data[0].idmaestrocoopv + '').style.background = "#f47216";
                            document.getElementById('' + response.data[0].idmaestrocoopv + '').style.color = "#fff";
                            document.getElementById('' + response.data[0].idmaestrocoopv + '').style.fontWeight = "bold";
                        }
                    } else {
                        this.setState({
                            estadoNuevo: true
                        })
                    }
                } else {
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    cambioImagen = (name, file) => {
        this.setState({
            estadoCambioImg: true
        });
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    insertarDatos = () => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });
        if (!Object.keys(result).length) {
            // formulario validado
            var rutaIco = '';
            var capNombre = this.uploader.current.getFileName();
            if (capNombre === "") {
                Swal.fire({
                    icon: 'error',
                    title: 'Falta cargar la imagen.'
                })
                return
            } else {
                rutaIco = '/iconos/CoopVirtualDetalle/' + this.uploader.current.getFileName();
            }
            const data = {
                tran: 1,
                idtipopers: this.state.idtipopers,
                titulo: this.state.titulo.toUpperCase(),
                rutaiconotit: rutaIco,
                descripcion: this.state.descripcion.toUpperCase(),
                estado: this.state.estado,
                idusucrea: sessionStorage.getItem('idusuario')
            }
            SeccionPMaestroCoopVirtualPOST_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        this.cargarImagen();
                        Swal.fire({
                            icon: 'success',
                            title: 'Se inserto correctamente.'
                        })
                        this.setState({
                            estadoNuevo: false,
                            descsimulador: '',
                        })
                        this.cargarInformacion();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al insertar.'
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    })
                }
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Campos incompletos!.'
            })
        }
    }

    cargarImagen = () => {
        var formData = new FormData();
        if (!this.uploader.current) return;

        formData.append("file", this.uploader.current.getFileObject());
        formData.append("rutaImagen", '/iconos/CoopVirtualDetalle/' + this.uploader.current.getFileName());
        CargueImagenes(formData).then(response => {
            if (response) {
                this.cargarInformacion();
            }
        });
    }

    busquedaId = (dataSe) => {
        document.getElementById('' + this.state.idPintar + '').style.background = "#fff";
        document.getElementById('' + this.state.idPintar + '').style.color = "#000";
        document.getElementById('' + this.state.idPintar + '').style.fontWeight = "normal";
        document.getElementById('' + dataSe.idmaestrocoopv + '').style.background = "#f47216";
        document.getElementById('' + dataSe.idmaestrocoopv + '').style.color = "#fff";
        document.getElementById('' + dataSe.idmaestrocoopv + '').style.fontWeight = "bold";
        this.setState({
            estadoCambioImg: false,
            est: !this.state.est,
            idSeleccionado: dataSe.idmaestrocoopv,
            idPintar: dataSe.idmaestrocoopv
        })
        const data = {
            tran: 5,
            idmaestrocoopv: dataSe.idmaestrocoopv,
            idtipopers: 1,
            titulo: 'NA',
            rutaiconotit: 'NA',
            descripcion: 'NA',
            estado: 1,
            idusucrea: 1
        }
        SeccionPMaestroCoopVirtual_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        if (response.data[0].message === "004404") {
                            this.setState({
                                estadoNuevo: true
                            })
                        } else {
                            this.setState({
                                editrutaiconotit: response.data[0].rutaiconotit,
                                idmaestrocoopv: response.data[0].idmaestrocoopv,
                                edittitulo: response.data[0].titulo,
                                idtipopers: response.data[0].idtipopers,
                                editdescripcion: response.data[0].descripcion,
                                estado: response.data[0].estado,
                                estadoNuevo: false,
                                stateImg: false,
                                estadoImagen: true,
                            })
                        }
                    } else {
                        this.setState({
                            estadoNuevo: true
                        })
                    }
                } else {
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    activar = (id) => {
        const data = {
            tran: 6,
            idmaestrocoopv: id,
            idtipopers: 0,
            titulo: 'NA',
            rutaiconotit: 'NA',
            descripcion: 'NA',
            estado: 1,
            idusucrea: sessionStorage.getItem('idusuario')
        }
        SeccionPMaestroCoopVirtualPOST_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                document.getElementById('' + this.state.idPintar + '').style.background = "#fff";
                document.getElementById('' + this.state.idPintar + '').style.color = "#000";
                document.getElementById('' + this.state.idPintar + '').style.fontWeight = "normal";
                this.cargarInformacion();
            }
        });
    }

    inactivar = (id) => {
        const data = {
            tran: 6,
            idmaestrocoopv: id,
            idtipopers: 0,
            titulo: 'NA',
            rutaiconotit: 'NA',
            descripcion: 'NA',
            estado: 0,
            idusucrea: sessionStorage.getItem('idusuario')
        }
        SeccionPMaestroCoopVirtual_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se inactivo satisfactoriamente'
                });
                document.getElementById('' + this.state.idPintar + '').style.background = "#fff";
                document.getElementById('' + this.state.idPintar + '').style.color = "#000";
                document.getElementById('' + this.state.idPintar + '').style.fontWeight = "normal";
                this.cargarInformacion();
            }
        });
    }

    actualizarDatos = (id) => {
        var rutaIco = '';
        var capNombre = this.uploader.current.getFileName();    
        if (capNombre === undefined || capNombre === null) {
            rutaIco = this.state.editrutaiconotit;
        } else {
            rutaIco = '/iconos/CoopVirtualDetalle/' + this.uploader.current.getFileName();
        }
        const data = {
            tran: 1,
            idmaestrocoopv: id,
            idtipopers: this.state.idtipopers,
            titulo: this.state.edittitulo.toUpperCase(),
            rutaiconotit: rutaIco,
            descripcion: this.state.editdescripcion.toUpperCase(),
            estado: this.state.estado,
            idusucrea: sessionStorage.getItem('idusuario')
        }
        SeccionPMaestroCoopVirtualPOST_(data).then(response => {
            if (response.data.length > 0) {
                if (response.data[0].message === "000000") {
                    this.cargarImagen();
                    this.setState({
                        estadoCambioImg: false,
                        color: '',
                        editposicion: null
                    })
                    Swal.fire({
                        icon: 'success',
                        title: 'Se actualizo correctamente.'
                    })
                    document.getElementById('' + this.state.idPintar + '').style.background = "#fff";
                    document.getElementById('' + this.state.idPintar + '').style.color = "#000";
                    document.getElementById('' + this.state.idPintar + '').style.fontWeight = "normal";
                    this.cargarInformacion();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al actualizar.'
                    })
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrio un error!'
                })
            }
        });
    }

    capturaChecked = (e) => {
        this.setState({
            checked: String(e.target.value),
        })
    }

    handleNew = () => {
        this.setState({
            estadoNuevo: !this.state.estadoNuevo,
            errors: {}
        })

        if (this.state.estadoNuevo) {
            this.setState({
                errors: {},
                titulo: '',
                descripcion: '',
            })
            this.cargarInformacion();
        }
    }

    render() {
        const { estadoNuevo, estadoCambioImg, errors, edittitulo, elementosData, editdescripcion, estadoImagen, editrutaiconotit  } = this.state;
        
        return (
            <React.Fragment>
                <p className="font-weight-bold">ELEMENTOS (Natural - Juridica)</p>
                <hr />
                <div className="plus_add_agencia align-items-center d-flex" onClick={() => { this.handleNew() }}>
                    {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Agregar Nuevo &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                </div>
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="container mt-5 pt-5">
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <MDBInput label="Titulo" type="text" name="titulo" value={this.state.titulo} onChange={this.textInput} />
                                    {errors.titulo && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '57px' }}>{errors.titulo}</strong>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 my-2">
                                    <label>Tipo Persona</label>
                                    <select name="idtipopers" value={this.state.idtipopers} className="form-control" onChange={this.textInput}>
                                        <option value="DEFAULT" >Seleccione...</option>
                                        <option value="1">Natural</option>
                                        <option value="0">Jurídica</option>
                                    </select>
                                    {errors.idtipopers && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.idtipopers}</strong>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <FileUploaderIcon ref={this.uploader} estadoImg={true} key="trueView" FCambiar={this.cambioImagen} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <MDBInput label="Descripción" type="textarea" name="descripcion" value={this.state.descripcion} onChange={this.textInput} />
                                    {errors.descripcion && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '57px' }}>{errors.descripcion}</strong>}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={this.insertarDatos}>Guardar nuevo &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                            <div className="listado_banner_transaccional pt-5">
                            <p>Seleccionar Elemento</p>
                                <ul>
                                    {elementosData.map((e, i) => {
                                    let view;
                                    if (e.estado === 1) {
                                        view = <MDBIcon onClick={() => { this.inactivar(e.idmaestrocoopv) }} icon="eye" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    } else {
                                        view = <MDBIcon onClick={() => { this.activar(e.idmaestrocoopv) }} icon="eye-slash" size="lg" style={{ color: 'black', position: 'absolute', right: '-38px', marginTop: '5px' }} />
                                    }
                                        return [
                                            <li key={i} id={e.idmaestrocoopv} onClick={() => { this.busquedaId(e) }}>{e.titulo} {view}</li>
                                    ]
                                })}
                            </ul>
                        </div>
                        <div className="container mt-5 pt-5 pb-5 formulario_transaccional">
                            <div className="row">
                                <div className="col-md-12">
                                        <MDBInput label="Nombre Producto" disabled={false} name="edittitulo" type="text" value={edittitulo} onChange={this.textInput} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 my-2">
                                    <label className="c" >Tipo Persona</label>
                                    <select name="idtipopers" value={this.state.idtipopers} className="form-control" onChange={this.textInput} disabled={true}>
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="1">Natural</option>
                                        <option value="0">Jurídica</option>
                                    </select>
                                    {errors.idtipopers && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.idtipopers}</strong>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    {estadoImagen ? (
                                            <FileUploaderIcon ref={this.uploader} ruta={editrutaiconotit} key="falseView" estadoImg={estadoCambioImg} FCambiar={this.cambioImagen} />
                                    ) : (
                                        <React.Fragment></React.Fragment>
                                    )}
                                </div>
                            </div>
                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <MDBInput label="Descripción" type="textarea" name="editdescripcion" value={editdescripcion} onChange={this.textInput} />
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="buttom" className="btn btn-success px-5" onClick={() => { this.actualizarDatos(this.state.idSeleccionado) }}>Guardar cambios &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default SElemento;